import { w as ensure_array_like } from "../../../../chunks/index2.js";
import { p as page } from "../../../../chunks/index3.js";
import { e as escape_html } from "../../../../chunks/escaping.js";
import { a as attr } from "../../../../chunks/attributes.js";
function _layout($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { children, data } = $$props;
    let pages = [
      // { path: '/admin/home', name: 'Home' },
      // { path: '/admin/aktualnosci', name: 'Aktualności' },
      // { path: '/admin/kadra', name: 'Kadra' }
    ];
    $$renderer2.push(`<header class="header container svelte-1uz152k">`);
    if (data.user) {
      $$renderer2.push("<!--[-->");
      $$renderer2.push(`<span>Witaj ${escape_html(data.user.username)}</span> <nav class="nav svelte-1uz152k"><!--[-->`);
      const each_array = ensure_array_like(pages);
      for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
        let page$1 = each_array[$$index];
        $$renderer2.push(`<a${attr("href", page$1.path)} class="nav-item svelte-1uz152k"${attr("aria-current", page.url.pathname === page$1.path ? "page" : void 0)}>${escape_html(page$1.name)}</a>`);
      }
      $$renderer2.push(`<!--]--></nav> <div><button class="btn btn--light">Wyloguj</button></div>`);
    } else {
      $$renderer2.push("<!--[!-->");
    }
    $$renderer2.push(`<!--]--></header> <main class="container admin-main svelte-1uz152k">`);
    children($$renderer2);
    $$renderer2.push(`<!----></main>`);
  });
}
export {
  _layout as default
};
//# sourceMappingURL=_layout.svelte.js.map
